import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EnhancedSidebar } from '@/components/common/EnhancedSidebar';
import { HeaderNav } from '@/components/common/HeaderNav';
import { useIsAuthenticated } from '@/hooks/redux';
import { cn, showToastMessage } from '@/utils';
import { RootState } from '@/store';
import { useDispatch, useSelector } from 'react-redux';
import { useAvailbleRolesQuery, useGetWalletQuery, useLogoutMutation } from '@/store/api/authApi';
import { clearUser, setMainAmount } from '@/store/slices/userSlice';
import { logout as clearAuth } from '@/store';
import apiSlice from '@/store/api/apiSlice';
import { Modal } from '@/components/common/Modal';
import { ChangePassword } from '@/components/common/ChangePassword';
export function DashboardLayout() {
  const [logout] = useLogoutMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ismobile = window.innerWidth < 768;
  const [sidebarOpen, setSidebarOpen] = React.useState(!ismobile);
  const isAuthenticated = useIsAuthenticated();

  useAvailbleRolesQuery(undefined, { skip: !isAuthenticated });
  const { data } = useGetWalletQuery(undefined, { skip: !isAuthenticated, pollingInterval: 20000 });

  const [userClosed, setUserClosed] = React.useState(false);
  const user = useSelector((state: RootState) => state.user);
  const closeModal = () => setUserClosed(true);
  const showModal = Boolean(user.data && user.data.passwordChanged === false && !userClosed);

  useEffect(() => {
    if (data) {
      dispatch(setMainAmount(data.find((wallet) => wallet.type === 'Main')?.amount ?? '0'));
    }
  }, [data, dispatch]);
  const mainAmount = useSelector((state: RootState) => state.user.mainAmount);

  const handleUserLogout = async () => {
    try {
      await logout().unwrap();
      dispatch(clearAuth());
      dispatch(clearUser());
      dispatch(apiSlice.util.resetApiState());
      showToastMessage('success', 'You have been logged out successfully.');
      navigate('/login');
    } catch (err: any) {
      showToastMessage('error', err?.data?.message || 'Failed to logout. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-background ">
      {/* Enhanced Sidebar */}
      <EnhancedSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

      {/* Main Content */}
      <div
        className={cn('transition-all duration-300', sidebarOpen ? 'lg:ml-[243px]' : 'lg:ml-16')}
      >
        {/* Top Navigation */}
        <header className="sticky top-0 z-40 backdrop-blur bg-white shadow-sm">
          <div className="flex h-20 items-center px-4 ">
            {/* Mobile menu button */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className=""
              // className="md:hidden"
            >
              <Menu className="h-5 w-5" />
            </Button>

            {/* <div className="ml-auto flex items-center gap-3 ">
              <span className="max-md:hidden text-sm font-medium">Multi-Factor Authentication</span>
              <span className="md:hidden text-sm font-medium">MFA</span>
              <Switch
                aria-label="Toggle MFA"
                className="data-[state=checked]:bg-emerald-700 data-[state=unchecked]:bg-slate-500 [&>span]:!bg-white"
                checked={Boolean(mfaStatus?.isMfaEnabled)}
                disabled={isFetchingMfaStatus}
                onCheckedChange={(checked) => openMfaModal(checked ? 'enable' : 'disable')}
              />
            </div> */}

            <HeaderNav
              mainAmount={mainAmount}
              onChangePassword={() => navigate('/settings')}
              onLogout={handleUserLogout}
            />
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 min-h-[calc(100dvh-65px)]">
          <Outlet />
        </main>
      </div>
      {showModal && (
        <Modal
          open={showModal}
          style="top-[25%] left-1/2 -translate-x-1/2 border-green rounded-2xl shadow-sm "
          bgBlur={true}
        >
          <ChangePassword close={closeModal} title={true} />
        </Modal>
      )}
    </div>
  );
}
